<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Multicolor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 112">
    <title>01- user</title>
    <g id="Background">
      <g
        id="New_Symbol_58-3"
        data-name="New Symbol 58">
        <path
          class="cls-1"
          d="M90.5,56A40,40,0,1,0,14.06,72.5H86.94A39.85,39.85,0,0,0,90.5,56Z" />
        <path
          class="cls-2"
          d="M14.06,72.5a40,40,0,0,0,72.88,0Z" />
        <line
          class="cls-3"
          x1="11"
          y1="72.5"
          x2="89"
          y2="72.5" />
        <line
          class="cls-3"
          x1="6.5"
          y1="72.5"
          x2="9"
          y2="72.5" />
        <line
          class="cls-3"
          x1="91"
          y1="72.5"
          x2="93.5"
          y2="72.5" />
      </g>
    </g>
    <g id="Scene">
      <ellipse
        class="cls-4"
        cx="50"
        cy="82.04"
        rx="9.2"
        ry="1.73" />
      <path
        class="cls-1"
        d="M55.36,28.2a5.36,5.36,0,1,1-10.72,0V25.52a5.36,5.36,0,1,1,10.72,0Z" />
      <path
        class="cls-5"
        d="M55.36,28.2a5.36,5.36,0,1,1-10.72,0V25.52a5.36,5.36,0,1,1,10.72,0Z" />
      <path
        class="cls-2"
        d="M50,20.15a5.36,5.36,0,0,0-5.36,5.37v1.79a5.27,5.27,0,0,0,.09.89,5.34,5.34,0,0,1,10.54,0,5.27,5.27,0,0,0,.09-.89V25.52A5.36,5.36,0,0,0,50,20.15Z" />
      <path
        class="cls-1"
        d="M50,35.86c-5.93,0-11.62,4.81-11.62,10.73V59.11a2.68,2.68,0,0,0,5.36,0l1.53,19.06a3.57,3.57,0,0,0,3.56,3.29h2.34a3.57,3.57,0,0,0,3.56-3.29l1.53-19.06a2.68,2.68,0,0,0,5.36,0V46.59C61.62,40.67,55.93,35.86,50,35.86Z" />
      <path
        class="cls-2"
        d="M50,35.86c-5.93,0-11.62,4.81-11.62,10.73l.89,4.47c0-5.92,2.42-10.73,10.73-10.73s10.73,4.81,10.73,10.73l.89-4.47C61.62,40.67,55.93,35.86,50,35.86Z" />
      <path
        class="cls-3"
        d="M55.36,28.2a5.36,5.36,0,1,1-10.72,0V25.52a5.36,5.36,0,1,1,10.72,0Z" />
      <line
        class="cls-3"
        x1="43.74"
        y1="59.11"
        x2="43.74"
        y2="47.49" />
      <line
        class="cls-3"
        x1="56.26"
        y1="59.11"
        x2="56.26"
        y2="47.49" />
      <path
        class="cls-3"
        d="M50,35.86c-5.93,0-11.62,4.81-11.62,10.73V59.11a2.68,2.68,0,0,0,5.36,0l1.53,19.06a3.57,3.57,0,0,0,3.56,3.29h2.34a3.57,3.57,0,0,0,3.56-3.29l1.53-19.06a2.68,2.68,0,0,0,5.36,0V46.59C61.62,40.67,55.93,35.86,50,35.86Z" />
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  .cls-1 {
    fill: #e8f4fa;
  }

  .cls-2 {
    fill: #fff;
  }

  .cls-3 {
    fill: none;
  }

  .cls-3,
  .cls-5 {
    stroke: #191816;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  .cls-4 {
    fill: #231f20;
    opacity: 0.15;
  }

  .cls-5 {
    fill: #daedf7;
  }
</style>
